var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M40,4c19.9,0,36,16.1,36,36c0,19.9-16.1,36-36,36C20.1,76,4,59.9,4,40C4,20.1,20.1,4,40,4z M59.4,27.9 c-1.4,0.6-3,1.1-4.6,1.3c1.6-1,2.9-2.5,3.5-4.4c-1.5,0.9-3.3,1.6-5.1,1.9c-1.5-1.6-3.5-2.5-5.8-2.5c-4.4,0-8,3.6-8,8 c0,0.6,0.1,1.2,0.2,1.8c-6.6-0.3-12.5-3.5-16.4-8.3c-0.7,1.2-1.1,2.6-1.1,4c0,2.8,1.4,5.2,3.5,6.6c-1.3,0-2.5-0.4-3.6-1v0.1 c0,3.9,2.7,7.1,6.4,7.8c-0.7,0.2-1.4,0.3-2.1,0.3c-0.5,0-1,0-1.5-0.2c1,3.2,4,5.5,7.5,5.6c-2.7,2.1-6.2,3.4-9.9,3.4 c-0.6,0-1.3,0-1.9-0.1c3.5,2.3,7.7,3.6,12.2,3.6c14.7,0,22.7-12.2,22.7-22.7c0-0.3,0-0.7,0-1C57,31,58.4,29.5,59.4,27.9L59.4,27.9z"
});

function SvgIconTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTw);
export default __webpack_public_path__ + "static/media/icon_tw.1aaa8ee4.svg";
export { ForwardRef as ReactComponent };